var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-chip',{staticClass:"s-chip q-mx-none q-my-xs",attrs:{"outline":"","square":"","size":"md","color":_vm.bgColorChip,"text-color":"white","icon":_vm.iconChip}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }